import React from "react";
const SmileLargeIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={62}
      height={62}
      viewBox="0 0 62 62"
      xmlns="http://www.w3.org/2000/svg"
      fill="var(--color-theme-600)"
      ref={svgRef}
      {...props}
    >
      <g fillRule="evenodd">
        <circle cx={31} cy={31} r={31} />
        <path d="M31 0c17.12 0 31 13.88 31 31 0 17.12-13.88 31-31 31C13.88 62 0 48.12 0 31c0-.516.013-1.029.038-1.539C.798 44.246 13.026 56 28 56c15.464 0 28-12.536 28-28C56 13.026 44.246.798 29.462.037 29.97.013 30.484 0 31 0z" />
        <path d="M31 0c10.09 0 19.055 4.82 24.716 12.285A30.863 30.863 0 0037 6C19.88 6 6 19.88 6 37c0 7.03 2.34 13.514 6.284 18.715C4.821 50.055 0 41.09 0 31 0 13.88 13.88 0 31 0z" />
        <circle stroke="#000" strokeWidth={3} cx={31} cy={31} r={29.5} />
        <path d="M52.494 32c-.266 10.263-8.668 18.5-18.994 18.5S14.772 42.263 14.506 32h37.988z" />
        <path
          d="M50.887 33.5a17.45 17.45 0 01-5.178 10.537A17.443 17.443 0 0133.5 49a17.443 17.443 0 01-12.21-4.963 17.45 17.45 0 01-5.177-10.536h0z"
          stroke="#000"
          strokeWidth={3}
        />
        <circle cx={26} cy={24} r={4} />
        <circle cx={44} cy={24} r={4} />
      </g>
    </svg>
  )
);
SmileLargeIcon.displayName = "SmileLargeIcon";
export default SmileLargeIcon;
